<template>
  <div class="center_box" :class="{ 'compact-order-workspace': $route.path.includes('photography-appointment') || ['/center/ownlease', '/center/ownMetope'].includes($route.path) }">
    <center-user v-if="is_login" />
    <div v-if="!is_login" class="account-state">
      请先登录后管理账户。<router-link to="/login">前往登录</router-link>
    </div>
    <div v-else class="account-workspace">
      <aside class="account-sidebar" aria-label="个人中心导航">
        <p>个人中心</p>
        <h2><img src="@/assets/images/account/9d7fe.svg" alt="" />账户管理</h2>
        <router-link to="/center/basic">基本资料</router-link
        ><router-link to="/center/pwd">修改密码</router-link>
        <hr />
        <details class="order-navigation" :open="$route.path.includes('photography-appointment')">
          <summary>
            <img src="@/assets/images/account/88678.svg" alt="" />我的订单<img
              class="nav-chevron"
              src="@/assets/images/account/4d902.svg"
              alt=""
            />
          </summary>
          <router-link
            v-for="item in [
              ['ownPurchase', '购买订单'],
              ['ownlease', '租赁订单'],
              ['photography-appointments', '摄影预约'],
              ['site', '场地订单'],
              ['ownService', '服务订单'],
              ['ownMetope', '制作订单'],
            ]"
            :key="item[0]"
            :to="'/center/' + item[0]"
            >{{ item[1] }}</router-link
          >
        </details>
        <details class="account-more">
          <summary>更多功能</summary>
          <h3>我的身份</h3>
          <router-link to="/center/camera">服饰管理</router-link
          ><router-link v-if="user_type == 23" to="/center/field"
            >场地管理</router-link
          >
          <h3>原创作者</h3>
          <router-link to="/center/original/data">基本资料</router-link
          ><router-link to="/center/original/list">上传模板</router-link>
          <h3>接单</h3>
          <router-link
            v-for="item in [
              ['purchase', '购买订单'],
              ['lease', '租赁订单'],
              ['service', '服务订单'],
              ['store', '制作订单'],
            ]"
            :key="item[0]"
            :to="'/center/' + item[0]"
            >{{ item[1] }}</router-link
          ><router-link
            v-if="user_type == 21 || user_type == 22"
            to="/center/photography"
            >摄影订单</router-link
          ><router-link to="/center/wallet">账单明细</router-link>
        </details>
      </aside>
      <main class="center_right_box" :aria-busy="profileLoading">
        <div v-if="profileLoading" class="account-state" role="status">
          正在加载账户资料…
        </div>
        <div v-else-if="basic_data_error" class="account-state" role="alert">
          {{ basic_data_error }}
          <el-button size="small" @click="loadProfile">重新加载</el-button>
        </div>
        <router-view v-if="!['/center/basic', '/center/pwd'].includes($route.path) || (!profileLoading && !basic_data_error)" :key="$store.state.user.user_id" />
      </main>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      activeMenu: "/center/basic",
      profileLoading: true,
    };
  },
  computed: mapState({
    user_type: (state) => state.user.user_type,
    basic_data: (state) => state.user.basic_data,
    is_login: (state) => state.user.is_login,
    basic_data_error: (state) => state.user.basic_data_error,
  }),
  components: {
    centerUser: () => import("@/components/centerUser"),
    centerUserBalance: () => import("@/components/centerUserBalance"),
  },
  methods: {
    ...mapActions(["getBasicData"]),
    async loadProfile() {
      this.profileLoading = true;
      try {
        await this.getBasicData();
      } finally {
        this.profileLoading = false;
      }
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 高亮菜单写入
    handleSelect(menu) {
      this.activeMenu = menu;
    },
  },
  mounted() {
    // 加载页面时，更新导航栏高亮位置
    this.handleSelect(this.$route.path);
  },
  beforeRouteEnter(to, from, next) {
    // ...
    next((vm) => {
      vm.loadProfile();
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  watch: {
    "$store.state.user.user_id"() {
      if (this.is_login) this.loadProfile();
    },
    $route() {
      // 监听路由跳转，更新导航栏高亮位置
      this.handleSelect(this.$route.path);
    },
  },
};
</script>

<style scoped>
.center_box {
  background: #f7f7fa;
  min-height: 750px;
  color: #24242a;
}
.account-workspace {
  max-width: 1280px;
  margin: auto;
  padding: 32px 0 64px;
  display: flex;
  gap: 32px;
  align-items: flex-start;
}
.account-sidebar {
  width: 230px;
  flex-shrink: 0;
  padding-top: 8px;
}
.account-sidebar > p {
  font-size: 12px;
  color: #a2a2ac;
  margin: 0 0 28px;
}
.account-sidebar h2 {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  margin: 0;
  height: 44px;
}
.account-sidebar h2 img,
.account-sidebar summary > img:first-child {
  width: 20px;
  height: 20px;
}
.account-sidebar a {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 20px;
  margin: 6px 0;
  color: #777780;
  font-size: 15px;
  border-radius: 100px;
  box-sizing: border-box;
}
.account-sidebar a.router-link-active {
  background: white;
  color: #6b5dd5;
  box-shadow: 0 5px 18px #6356ba14;
}
.account-sidebar hr {
  border: 0;
  border-top: 1px solid #e9e9ef;
  margin: 28px 0;
}
.account-sidebar summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 0 16px;
  color: #777780;
  cursor: pointer;
  font-size: 15px;
  list-style: none;
}
.account-sidebar .nav-chevron {
  width: 14px;
  height: 14px;
  margin-left: auto;
}
.account-sidebar h3 {
  font-size: 13px;
  padding: 0 16px;
  color: #777780;
}
.account-more {
  margin-top: 20px;
}
.account-more > summary {
  font-size: 12px;
}
.center_right_box {
  flex: 1;
  min-width: 0;
}
.account-state {
  padding: 20px;
  background: white;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1340px) {
  .account-workspace {
    margin: 0 24px;
  }
}
@media (max-width: 700px) {
  .account-workspace {
    margin: 0;
    padding: 20px 16px;
    display: block;
  }
  .account-sidebar {
    width: auto;
    padding: 0;
    margin-bottom: 20px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
  }
  .account-sidebar > p,
  .account-sidebar h2,
  .account-sidebar hr {
    display: none;
  }
  .account-sidebar > a {
    font-size: 14px;
    padding: 0 16px;
  }
  .account-sidebar details {
    width: 100%;
  }
  .account-sidebar .account-more {
    margin-top: 0;
  }
  .account-sidebar details:not([open]) {
    width: auto;
  }
  .account-sidebar summary {
    padding: 0 8px;
  }
}
@media(max-width:700px) {
  .compact-order-workspace .order-navigation[open] { display:block; width:100%; overflow-x:auto; white-space:nowrap; padding-bottom:4px; }
  .compact-order-workspace .order-navigation[open] > summary { display:inline-flex; vertical-align:middle; }
  .compact-order-workspace .order-navigation[open] > a { display:inline-flex; align-items:center; min-height:44px; padding:0 16px; margin:0; vertical-align:middle; }
  .compact-order-workspace .order-navigation[open] .nav-chevron { display:none; }
  .compact-order-workspace .order-navigation[open] > a:focus-visible { outline:2px solid #6b5dd5; outline-offset:-3px; }
}
</style>
